// PDF-ийг pdf.js-ээр хуудас бүрийг canvas болгон зурна — утасны хөтөч (Android Chrome, iPhone Safari) iframe дотор PDF харуулдаггүй.
// iframe биш тул PDF дээр дарахад шалгалтын түгжээ "өөр цонх руу гарсан" гэж андуурахгүй.
import React, { useEffect, useRef, useState } from "react";
import { Spin } from "antd";

let lib = null;
const loadLib = async () => {
  if (lib) return lib;
  lib = await import("pdfjs-dist/build/pdf");
  lib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;
  return lib;
};

function Page({ pdf, n, width, zoom }) {
  const ref = useRef(null);
  useEffect(() => {
    let task;
    let alive = true;
    pdf.getPage(n).then((page) => {
      if (!alive || !ref.current) return;
      const base = page.getViewport({ scale: 1 });
      const cssW = width * zoom;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const vp = page.getViewport({ scale: (cssW / base.width) * dpr });
      const c = ref.current;
      c.width = vp.width; c.height = vp.height;
      c.style.width = `${cssW}px`; c.style.height = `${(vp.height / dpr)}px`;
      task = page.render({ canvasContext: c.getContext("2d"), viewport: vp });
      task.promise.catch(() => {});
    });
    return () => { alive = false; task?.cancel?.(); };
  }, [pdf, n, width, zoom]);
  return <canvas ref={ref} aria-label={`${n}-р хуудас`} className="block mx-auto bg-white shadow-sm" />;
}

export default function PdfPages({ url, name }) {
  const box = useRef(null);
  const [pdf, setPdf] = useState(null);
  const [err, setErr] = useState(false);
  const [width, setWidth] = useState(0);
  const [zoom, setZoom] = useState(1);
  useEffect(() => {
    let alive = true;
    let doc;
    setPdf(null); setErr(false);
    loadLib().then((L) => L.getDocument(url).promise).then((d) => { doc = d; if (alive) setPdf(d); else d.destroy(); }).catch(() => alive && setErr(true));
    return () => { alive = false; doc?.destroy?.(); };
  }, [url]);
  useEffect(() => {
    if (!box.current) return undefined;
    const measure = () => setWidth(Math.max(240, (box.current?.clientWidth || 600) - 16));
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(box.current);
    return () => ro.disconnect();
  }, []);
  const z = (d) => setZoom((v) => Math.min(3, Math.max(0.5, Math.round((v + d) * 100) / 100)));
  return (
    <div className="relative h-full">
      <div className="sticky top-0 z-10 flex justify-end gap-1 p-1.5 pointer-events-none">
        <span className="pointer-events-auto inline-flex items-center gap-1 rounded-lg bg-white/90 border border-gray-200 px-1 shadow-sm">
          <button type="button" onClick={() => z(-0.25)} aria-label="Жижигрүүлэх" className="w-8 h-8 text-lg">−</button>
          <span className="text-xs w-10 text-center tabular-nums">{Math.round(zoom * 100)}%</span>
          <button type="button" onClick={() => z(0.25)} aria-label="Томруулах" className="w-8 h-8 text-lg">+</button>
        </span>
      </div>
      <div ref={box} className="overflow-x-auto px-2 pb-2 flex flex-col gap-3" aria-label={name}>
        {err ? <div className="py-10 text-center text-sm text-red-600">PDF нээж чадсангүй. Хуудсаа дахин ачаалж үзнэ үү.</div>
          : !pdf || !width ? <div className="py-16 flex justify-center"><Spin /></div>
            : Array.from({ length: pdf.numPages }, (_, i) => <Page key={i} pdf={pdf} n={i + 1} width={width} zoom={zoom} />)}
      </div>
    </div>
  );
}
